// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1xafw","choiceBoxes":"toolbarselects_choiceBoxes__2KJ-t","simpleField":"toolbarselects_simpleField__2j4Lu"};